import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import UpLoadingBar from '../../components/Common/UpLoadingBar';
import UpLoadingCover from '../../components/Common/UpLoadingCover';
import PlaceholderBiz from '../../assets/images/placeholder-biz.svg';
import ArrowRightIcon from '../../assets/icons/ArrowRightIcon';
import { getLinkedBrands } from '../../helpers/bizDataHelpers';
import CardHeader from '../../components/CardHeader';
import RightArrowIcon from '../../assets/icons/RightArrowIcon';
import LocalStorageHelper from '../../helpers/localStorageHelpers';
import usePlatformRedirect from '../../helpers/usePlatformRedirect';

function SelectBrand() {
  const navigate = useNavigate();
  const { bizId, platform } = useParams();
  const brandList = getLinkedBrands(bizId, platform);
  const redirectHost = LocalStorageHelper.getRedirectHost();

  const {
    isLoading,
    redirect: callRedirectPlatform,
    atlasEnvPicker,
  } = usePlatformRedirect();

  function redirectToBizPlatform(brand) {
    callRedirectPlatform({
      appType: platform,
      params: {
        app_name: platform,
        biz_id: Number(bizId),
        app_biz_id: brand?.app_biz_id,
        redirect_host: redirectHost,
      },
    });
  }

  if (!brandList || brandList?.length === 0) {
    return <Navigate to={'/business'} />;
  }

  return (
    <div>
      {atlasEnvPicker}
      <UpLoadingBar loading={isLoading} />
      <div className="light-view-wrapper relative">
        <UpLoadingCover loading={isLoading} />
        <button
          onClick={() => navigate(`/business/${bizId}`)}
          aria-label={`Back to app selection (${platform})`}
          className="text-sm text-up-clr-light-grey mb-1 flex items-center cursor-pointer bg-transparent border-0 p-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-up-clr-primary focus-visible:ring-offset-2 rounded">
          <span className="mr-1 capitalize">{platform}</span>
          <RightArrowIcon />
        </button>
        <CardHeader title="Select a Prime company" wrapperClass="pb-6" />
        {!!brandList?.length && (
          <p className="text-sm text-up-clr-light-grey py-2" aria-hidden="true">
            Your companies ({brandList?.length})
          </p>
        )}
        <ul role="list" aria-label={`Companies (${brandList?.length})`}>
          {brandList?.map((brand, idx) => {
            return (
              <li key={brand?.app_biz_id}>
                <BrandCard
                  brand={brand}
                  redirectToBizPlatform={redirectToBizPlatform}
                />
                {idx < brandList?.length - 1 && (
                  <div aria-hidden="true" className="border-t border-up-clr-neutral-grey md:-mx-8" />
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

function BrandCard({ brand, redirectToBizPlatform }) {
  function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      redirectToBizPlatform(brand);
    }
  }

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={brand?.app_biz_name}
      onClick={() => redirectToBizPlatform(brand)}
      onKeyDown={handleKeyDown}
      className="my-6 flex items-center cursor-pointer transition-colors duration-500 text-up-clr-neutral-grey hover:text-up-clr-tinted-grey focus:outline-none focus-visible:ring-2 focus-visible:ring-up-clr-primary focus-visible:ring-offset-2 rounded">
      <div aria-hidden="true" className="w-12 h-12 flex-shrink-0 self-start">
        <img
          src={brand?.app_biz_logo || PlaceholderBiz}
          alt=""
          className="w-full h-full object-contain"
        />
      </div>
      <div style={{ maxWidth: 300 }} className="ml-4 mr-auto">
        <p aria-hidden="true" className="text-lg font-semibold text-up-clr-black leading-6">
          {brand?.app_biz_name}
        </p>
      </div>
      <div aria-hidden="true" className="p-2 select-none">
        <ArrowRightIcon />
      </div>
    </div>
  );
}

export default SelectBrand;
